import { render, staticRenderFns } from "./InterventionPlanDocument.vue?vue&type=template&id=bbf31e6e&scoped=true"
import script from "./InterventionPlanDocument.vue?vue&type=script&lang=js"
export * from "./InterventionPlanDocument.vue?vue&type=script&lang=js"
import style0 from "./InterventionPlanDocument.vue?vue&type=style&index=0&id=bbf31e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf31e6e",
  null
  
)

export default component.exports